import { render, staticRenderFns } from "./CompanyEmployeeAndBillingHistory.vue?vue&type=template&id=35805657&scoped=true&"
import script from "./CompanyEmployeeAndBillingHistory.vue?vue&type=script&lang=ts&"
export * from "./CompanyEmployeeAndBillingHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35805657",
  null
  
)

export default component.exports